
(() => {
  // ATHLETEGY - Mobile Shop the Look carousel
  // Keep only the active product's information visible.

  function initializeCarousels() {
    document.querySelectorAll(
      ".shop-the-look__popover scroll-carousel.shop-the-look__item-carousel"
    ).forEach((carousel) => {

      if (carousel.dataset.athletegyTracking === "true") return;

      const slides = Array.from(
        carousel.querySelectorAll(
          ":scope > .shop-the-look__item-product"
        )
      );

      if (!slides.length) return;

      function setActive(index) {
        slides.forEach((slide, i) => {
          slide.dataset.athletegyInactive =
            i === index ? "false" : "true";
        });
      }

      // Start with the first selected product.
      const initialIndex = slides.findIndex(
        slide => slide.classList.contains("is-selected")
      );
      setActive(initialIndex >= 0 ? initialIndex : 0);

      // Follow Prestige's native carousel changes.
      carousel.addEventListener("carousel:change", (event) => {
        const index = Number.isInteger(event.detail?.index)
          ? event.detail.index
          : slides.indexOf(event.detail?.cell);

        if (index >= 0 && index < slides.length) {
          setActive(index);
        }
      });

      carousel.dataset.athletegyTracking = "true";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCarousels);
  } else {
    initializeCarousels();
  }

  document.addEventListener("shopify:section:load", initializeCarousels);
})();
